
import React from "react";
import ReactDOM from "react-dom"; // Import from 'react-dom'
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

// Use ReactDOM.render instead of createRoot
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
